module.exports = __webpack_public_path__ + "img/f43d787.png";